import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, Divider, Typography, CircularProgress } from '@mui/material';
import { LabelAndAnswerGrid } from '../pensionAggregate';
import { getUserPayments } from 'service';
import { makeStyles } from '@mui/styles';
import { strings } from 'i18n/Strings';

export interface IUserPayments {
  bankName: string,
  debitAccountName: string,
  debitDate: string,
  debitIban: string,
  initialDeposit: number,
  monthlyTopUp: number,
  oneTimeTopUp: number,
  paymentMethods: string,
};

const useStyles = makeStyles({
  paper: {
    width: '100%',
    padding: '10px',
  },
  title: {
    lineHeight: 1.334,
    color: '#1c3e41',
    fontWeight: 800,
    fontSize: '18px',
    fontFamily: 'Inter!important',
  },
  emptyPensionContainer: {
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    width: "100%",
  },
  emptyPensionText: {
    fontFamily: 'Inter!important',
    color: "#838383",
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.2,
  }
});

const Payments = (): JSX.Element => {
  const { id } = useParams();
  const classes = useStyles();
  const [paymentDetails, setPaymentDetails] = useState<IUserPayments[]>([]);
  const [loader, setLoader] = useState(false);

  const getPaymentDetails = (userId: string): void => {
    setLoader(true)
    getUserPayments(userId)
      .then(({ result }: { result: IUserPayments[] }): void => {
        setPaymentDetails(result);
        setLoader(false);
      }).catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }
  useEffect(() => {
    if (id) {
      getPaymentDetails(id);
    }
  }, [id]);

  return (
    <Box>
      {loader ? (<Box className={classes.emptyPensionContainer}> <CircularProgress /></Box>) : (
        <>
          {paymentDetails.length === 0 ? (
            <Paper className={classes.paper}>
              <Box className={classes.emptyPensionContainer}>
                <Typography className={classes.emptyPensionText}>
                  {strings.displayText.paymentsEmptyText}
                </Typography>
              </Box>
            </Paper>
          ) : (
            <Paper className={classes.paper}>
              <Typography p={2} className={classes.title}>{strings.displayText.paymentsTitle}</Typography>
              <Box sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "scroll" }}>
                {paymentDetails?.map((payment) => (
                  <>
                    <LabelAndAnswerGrid label={strings.displayText.bankNameLabel} answer={payment?.bankName || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.debitAccountNameLabel} answer={payment?.debitAccountName || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.debitDateLabel} answer={payment?.debitDate || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.debitIbanLabel} answer={payment?.debitIban || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.initialDepositLabel} answer={payment?.initialDeposit || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.monthlyTopUpLabel} answer={payment?.monthlyTopUp || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.oneTimeTopUpLabel} answer={payment?.oneTimeTopUp || "-"} />
                    <LabelAndAnswerGrid label={strings.displayText.paymentMethodsLabel} answer={payment?.oneTimeTopUp || "-"} />
                    <Box display={"flex"} justifyContent={"center"}>
                      <Divider sx={{ marginBlock: 2, width: '90%' }} />
                    </Box>
                  </>
                ))}
              </Box>
            </Paper>
          )}
        </>
      )}
    </Box >
  )
};

export default Payments;
